module.exports = __webpack_public_path__ + "static/media/ic_success_message.2834fb60.svg";